/**
 * Player-facing achievements UI:
 * - Progress hub Trophies tab + panel
 * - Trophy-button unviewed counts from achievement tiers
 * - Run-summary unlock / rating-revealed toasts
 *
 * Evaluation, persistence, backfill, and unviewed-tier storage stay enabled
 * regardless. Flip `BOGGLE_ACHIEVEMENTS_PLAYER_UI` to ship.
 */
export const BOGGLE_ACHIEVEMENTS_PLAYER_UI = false

export function isBoggleAchievementsPlayerUiEnabled(isDevMode = false): boolean {
  return BOGGLE_ACHIEVEMENTS_PLAYER_UI || isDevMode
}
